import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JWTUser, SubjectsModel } from 'Model';
import { UtilserviceService } from 'app/services/utilservice.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subjectcombination',
  templateUrl: './subjectcombination.component.html',
  styleUrls: ['./subjectcombination.component.scss']
})
export class SubjectcombinationComponent implements OnInit {

  domainSubjects: Array<any> = [];
  selectedSubject: Array<string> = [];
  @Input() isSubjectPopupVisible: boolean;   
  @Input() dismissable: boolean;
  user: JWTUser;
  style:any;
  @Output() closeEvent = new EventEmitter<any>();

  constructor(private util: UtilserviceService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.style = this.util.getDomainEnviroment().style;
    this.user = JSON.parse(this.util.getCurrentUser()); 
    this.validateMAndatoryCombo();
    this.user.selectedSubjects.forEach(e => {
      this.addOrRemoveSelectedSubjects(e)
    });     
    this.util.getsubjects().then(
      (data) =>{
        this.domainSubjects = data;        
      }
    );
  }

  validateMAndatoryCombo(){
    this.user.mandatorySubjects.forEach(s => {
      this.addOrRemoveSelectedSubjects(s);
    })
  }
  addOrRemoveSelectedSubjects(subject: string){
    if(this.isSubjectSelected(subject)){
      const indexToRemove = this.selectedSubject.indexOf(subject);
      if (indexToRemove !== -1) 
        this.selectedSubject.splice(indexToRemove, 1);        
    }
    else if (this.selectedSubject.length < this.user.maxCombo){
      this.selectedSubject.push(subject);
    }      
}

isSubjectSelected(subject: string){
  return this.selectedSubject.some(s => s == subject);
}

submitSelection(){
  if(this.selectedSubject.length === this.user.maxCombo){
    let data = new SubjectsModel();
    data.domain = this.user.domain;
    data.email = this.user.email;
    data.subjects = this.selectedSubject;
    this.user.selectedSubjects = this.selectedSubject;
    this.util.setAuthenticatedUserToken(this.user);
    this.util.submitSubjects(data).then(
      () => {
        this.closeEvent.emit(false);
        this.toastr.success("Submission Successful");
      }
    );
  }
}

close(){
  this.closeEvent.emit(false);
}

}
